<template>
  <div class="card"
       v-if="showComponent" :key="componentRefresh"
       :title="qaAble ? showIfHasPermission?.toString() : null"
  >
    <div class="card-header" :id="'ks_accordion_heading_'+_uid">
      <h2 class="mb-0">
        <button type="button" class="btn btn-link" data-toggle="collapse" :data-target="'#ks_accordion_collapse_'+_uid">
          {{ labelLink }}
        </button>
      </h2>
    </div>
    <div :id="'ks_accordion_collapse_'+_uid" class="collapse" :class="{'show': show}"
         :aria-labelledby="'ks_accordion_heading_'+_uid">
      <div class="card-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import checkPermissions from '../../mixins/checkPermissions';

export default {
  name: 'accordion-card',
  mixins: [checkPermissions],
  computed: {
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    labelLink: {
      type: String,
      required: true
    }
  }
}
</script>
